import { api } from "@/api/baseApi";
import { HUB_PREVIEW_LOCATIONS_HEADER } from "./hubPreviewProtocol";
import { useHubPreviewStore } from "./hubPreview";

/**
 * Inside the preview, sends the locations picked in the location picker with every API call (empty = all). The
 * previewed merchant comes from the signed preview token. Nothing is saved: the backend applies the selection to that
 * request only.
 */
export function applyHubPreviewHeaders(locationIds: readonly string[] = []) {
  const { merchantId } = useHubPreviewStore.getState();
  if (!merchantId) return;
  api.setExtraHeaders(locationIds.length > 0 ? { [HUB_PREVIEW_LOCATIONS_HEADER]: locationIds.join(",") } : {});
}
